import { useSelector } from 'react-redux';
import reportSvg from 'assets/icons/report.svg';
import usePendoTracking from 'customHooks/usePendoTracking';
import Button, { Color, Size } from 'lib/Button';
import { getBackupCurrentLineAllocation } from 'store/dealManagement/selectors';
import { getAllocatedFrames, getAllocatedImpressions } from 'store/dealManagement/selectors/availabilityAssets';
import { getDealType } from 'store/dealManagement/selectors/getDealType';
import { Store } from 'components/common/types/Store.types';
import { DealStatus, DealType } from 'components/common/types/Deal.types';
import { AllocationReportButtonProps } from './AllocationReportButton.types';

export const AllocationReportButton: React.FC<AllocationReportButtonProps> = ({ openReport }) => {
  const { getPendoDataId } = usePendoTracking();
  const dealType = useSelector(getDealType);
  const isGuaranteed = dealType === DealType.GUARANTEED;

  const {
    commonDeal: { bookingStatusCode },
    isFetchingAllocation,
  } = useSelector((state: Store) => state.dealManagement);

  const backupLineAllocation = useSelector(getBackupCurrentLineAllocation);
  const allocatedFrames = useSelector(getAllocatedFrames);
  const allocatedImpressions = useSelector(getAllocatedImpressions);

  const hasAllocationData = !!(
    backupLineAllocation.allocatedFrames ||
    backupLineAllocation.allocatedImpressions ||
    allocatedFrames ||
    allocatedImpressions
  );

  const isAllocationReportButtonDisabled =
    !hasAllocationData || bookingStatusCode === DealStatus.CANCELLED || isFetchingAllocation;

  if (!isGuaranteed) return null;

  return (
    <Button
      dataTestId="planner-right-sidebar-report-button"
      isDisabled={isAllocationReportButtonDisabled}
      label="Report"
      size={Size.WIDE}
      color={Color.TERTIARY}
      classNames="pointer-events-auto"
      onClick={openReport}
      svg={reportSvg}
      dataPendoId={getPendoDataId('Allocation report button')}
    />
  );
};
